import listApiCall from './list'

const ApiCall = {
  list: listApiCall
}

export default ApiCall
